<template>
  <a
    :href="href"
    class="night-action"
    target="_blank"
    rel="noopener noreferrer"
  >
    <svg class="night-action-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path v-if="kind === 'maps'" fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" />
      <path
        v-else
        fill="currentColor"
        d="M4 5h13a2 2 0 0 1 2 2v3.1a2.5 2.5 0 0 0 0 3.8V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3.1a2.5 2.5 0 0 0 0-3.8V7a2 2 0 0 1 2-2zm3.5 2.5v9h1.5v-9H7.5z"
      />
    </svg>
    <span><slot /></span>
  </a>
</template>

<script>
export default {
  name: 'PublicNightLink',
  props: {
    href: { type: String, required: true },
    kind: { type: String, required: true, validator: (v) => v === 'maps' || v === 'tickets' },
  },
};
</script>

<style scoped>
.night-action {
  display: inline-flex;
  align-items: center;
  gap: 0.35em;
  color: #f0c14b;
  text-decoration: none;
}
.night-action-icon {
  width: 1em;
  height: 1em;
  flex-shrink: 0;
}
</style>
